import 'react-dropdown-tree-select/dist/styles.css'
import "react-multi-date-picker/styles/layouts/mobile.css"
import {useEffect, useState} from "react";
import "../styles.css";
import Loading from "../../../component/Loading/Loading";
import axios from "axios";
import {getManagerHeader} from "../../Login/functions";
import {baseCmsApiUrl} from "../../../assets/Constants";
import {base64DecodeUnicode, toastSuccess} from "../../../assets/functions";
import PageForm from "../component/PageForm/PageForm";
import {useNavigate, useParams} from "react-router-dom";
import {getPageById} from "../functions";

const UpdatePage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading , setIsLoading] = useState(true);

    const [page, setPage] = useState({
        background: "",
        title: "",
        rows: [],

    });

    const handleSubmit = async () => {
        setIsLoading(true);
        const headers = getManagerHeader();
        axios.put(baseCmsApiUrl + 'pages', page, {headers})
            .then((response) => {
                console.log(response)
                console.log(response.data)
                toastSuccess(base64DecodeUnicode(response.statusText));
                navigate("/pages");
                return;
            })
            .catch((e) => {
                console.error(e)
                console.log(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        (async () => {
            document.title = "ویرایش پیج" ;
            const page = await getPageById(id);
            setPage(page);
            setIsLoading(false);
        })();

    } , []);

    if (isLoading)
        return <Loading />

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">ویرایش پیج</h1>
            </div>
            <PageForm page={page} onChange={(value) => {
                setPage(value);
            }}/>
            <div className="col-12">
                <button type={"button"} className={"btn btn-success w-100 mt-5"} onClick={handleSubmit}>ویرایش پیج
                </button>
            </div>
        </div>

    );
}


export default UpdatePage;